export default {
  labels: {
    google_place: 'Google place',
    menu_import: 'Import meniu',
    live: 'Live',
    setting_up: 'În configurare',
  },
  buttons: {
    confirm: 'Confirmă',
    cancel: 'Anulează',
    continue_setup: 'Continuați configurarea',
  },
  delete_confirmation: 'Ești sigur?',
};
